import Vue from 'vue'

import Qs from 'qs'

class Countries {
  async suggest() {
    return await Vue.axios
      .get('app/countries/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/countries', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/countries', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/countries/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/countries/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/countries/' + id)
  }
}

const countries = new Countries()

export default countries
